import { render, staticRenderFns } from "./VirtualLogin.vue?vue&type=template&id=8ebab198&scoped=true&"
import script from "./VirtualLogin.vue?vue&type=script&lang=ts&"
export * from "./VirtualLogin.vue?vue&type=script&lang=ts&"
import style0 from "./VirtualLogin.vue?vue&type=style&index=0&id=8ebab198&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebab198",
  null
  
)

export default component.exports